import React, { useState } from "react";
import {
  Dialog, DialogActions, DialogContent, DialogContentText, Box, Button,
} from '@mui/material';
import sendRequest from '../utils/sendRequest';
import { SubmitButton, CancelButton } from "../styled/CustomButtons";
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function ApproveUpcDialog({ po_doc_id, poName, addSnackbar, fetchPoDetails=null, closeMoreActions }) {
  const [open, setOpen] = useState(false);
  const [loadingApproval, setLoadingApproval] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!loadingApproval) {
      setOpen(false);
      closeMoreActions();
    }
  };

  const approveUpcGeneration = async (po_doc_id) => {
    setLoadingApproval(true);
    try {
      let response = await sendRequest(`purchase-orders/approve-upc-generation?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
      handleClose();
      if (fetchPoDetails) fetchPoDetails();
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingApproval(false);
    }
  };

  return (
      <Box>
        <Button variant="text" onClick={handleOpen}>Approve UPC Generation</Button>
        <Dialog
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown={loadingApproval}
        >
          <CustomDialogTitle
            header={"Approve UPC Generation for Purchase Order"}
            poName={poName}
          />
          <DialogContent>
            <DialogContentText>
              Are all products approved for UPC generation?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <CancelButton onClick={handleClose} disabled={loadingApproval}>Cancel</CancelButton>
            <SubmitButton
              showSpinner={loadingApproval}
              text={"Approve UPC Generation"}
              onClick={() => approveUpcGeneration(po_doc_id)}
              disabled={loadingApproval}
            />
          </DialogActions>
        </Dialog>
      </Box>
  )
}